module.exports = "https://r.nearpod.com/assets/media/image/tiles-icon-1d19b23ec24935e82883e1d225042d60.svg";